import { catalogs } from "../../../utils/catalogs";
import { APPOINTMENT_OBJECTIVES, APPOINTMENT_STATUSES } from "../../../utils/enums";
import { onChangePeriod2UTCFormat } from "../../../utils/general";
import { getPatients } from "../../../services/userService";
import { yellow, amber, blue, blueGrey, brown, cyan, deepOrange, deepPurple, green, grey, indigo, lightBlue, lime, orange, pink, purple, red, teal } from '@mui/material/colors';

export const onGetCurrentPeriod = (period) => {
    const startdate = period.start_date
    const enddate = period.end_date
    let result = onChangePeriod2UTCFormat({
        start_date:startdate, end_date:enddate
    })
    return result
}


export const onGetFirstTimeAndFollowUpPatients = (users, appointments, period) => {

    let filter_appointments = appointments.filter(el => 
        ((el.appointment_status_id === APPOINTMENT_STATUSES.COMPLETED || 
        el.appointment_status_id === APPOINTMENT_STATUSES.COMPLETED_NO_ASSISTANCE)
        && el.start_date <= period.end_date)
    )

    let follow_up_patient_appointments = []
    let first_time_patient_appointments = []

    for (let index = 0; index < users.length; index++) {
        const element = users[index];
        const _appointments = filter_appointments.filter(el => el.user_id === element.user_id)
        const _appointments_in_period = _appointments.filter(el => el.start_date >= period.start_date && el.start_date <= period.end_date)
        const _appointments_before_period = _appointments.filter(el => el.start_date < period.start_date)
        /*console.log("paciente", element.user_id)
        console.log("Consultas en periodo", _appointments_in_period.length)
        console.log("Consultas antes periodo", _appointments_before_period.length)*/
        //console.log(_appointments.length === 1)
        if(_appointments_before_period.length > 0){
            follow_up_patient_appointments.push({
                user_id: element.user_id,
                gender_id: element.user_gender_id,
                client_id: element.user_client_id,
                client_location_id: element.user_client_location_id,
                appointments: _appointments,
                appointments_in_period:_appointments_in_period,
                appointments_before_period:_appointments_before_period,
                origin:element
            })
        }else if(_appointments.length > 0){
            first_time_patient_appointments.push({
                user_id: element.user_id,
                gender_id: element.user_gender_id,
                client_id: element.user_client_id,
                client_location_id: element.user_client_location_id,
                appointments: _appointments,
                appointments_in_period:_appointments_in_period,
                appointments_before_period:_appointments_before_period,
                origin:element
            })
        }
    }

    let scheduled_appointments = appointments.filter(el => 
        (el.appointment_status_id === APPOINTMENT_STATUSES.SCHEDULED
            && el.start_date > period.end_date
        )
    )

    const excludedUserIdsFirstTime = first_time_patient_appointments.map(item => item.user_id);
    scheduled_appointments = scheduled_appointments.filter(item => !excludedUserIdsFirstTime.includes(item.user_id));
    const excludedUserIdsFollowup = follow_up_patient_appointments.map(item => item.user_id);
    scheduled_appointments = scheduled_appointments.filter(item => !excludedUserIdsFollowup.includes(item.user_id));

    //scheduled_appointments = scheduled_appointments.filter(el => el.user_id)

    //console.log(scheduled_appointments)

    return {
        follow_up_users:  follow_up_patient_appointments,
        first_time_users: first_time_patient_appointments,
        valid_period_appointments: filter_appointments,
        scheduled_appointments: scheduled_appointments
    }
}

export const getAverageDataFromUsers = (users, first) => {
    let result = {
        imc_sum:0,
        imc_average:0,
        imc_count:0,
        weight_sum:0,
        weight_average:0,
        weight_count:0,
        waist_sum:0,
        waist_average:0,
        waist_count:0,
        hips_sum:0,
        hips_average:0,
        hips_count:0,
        icc_female_sum:0,
        icc_female_average:0,
        icc_female_count:0,
        icc_male_sum:0,
        icc_male_average:0,
        icc_male_count:0,
        muscle_mass_sum:0,
        muscle_mass_average:0,
        muscle_mass_count:0,
        fat_mass_sum:0,
        fat_mass_average:0,
        fat_mass_count:0,
        fat_percentage_sum:0,
        fat_percentage_average:0,
        fat_percentage_count:0,
    }

    for (let index = 0; index < users.length; index++) {
        const user = users[index];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }

        if(_appointment){
            // Check imc 
            const _weight = Number(_appointment?.weight)
            const _imc = Number(_appointment?.imc)
            const _hips = Number(_appointment?.circumference_hips)
            const _waist = Number(_appointment?.circumference_waist)
            const _icc = Number(_appointment?.icc)
            const _fat = Number(_appointment?.fat_mass)
            const _muscle = Number(_appointment?.muscle_mass)
            if(_weight){
                result.weight_sum = result.weight_sum + _weight
                result.weight_count = result.weight_count + 1
            }
            if(_imc){
                result.imc_sum = result.imc_sum + _imc
                result.imc_count = result.imc_count + 1
            }
            if(_hips){
                result.hips_sum = result.hips_sum + _hips
                result.hips_count = result.hips_count + 1
            }
            if(_waist){
                result.waist_sum = result.waist_sum + _waist
                result.waist_count = result.waist_count + 1
            }
            if(_fat){
                result.fat_mass_sum = result.fat_mass_sum + _fat
                result.fat_mass_count = result.fat_mass_count + 1
            }
            if(_muscle){
                result.muscle_mass_sum = result.muscle_mass_sum + _muscle
                result.muscle_mass_count = result.muscle_mass_count + 1
            }
            if(_icc > 0){
                if(user?.gender_id === 1){
                    result.icc_male_sum = result.icc_male_sum + _icc
                    result.icc_male_count = result.icc_male_count + 1
                }else{
                    result.icc_female_sum = result.icc_female_sum + _icc
                    result.icc_female_count = result.icc_female_count + 1
                }
                
            }
        }
        
    }

    if(result.weight_count > 0){
        result.weight_average = result.weight_sum/result.weight_count
    }
    if(result.imc_count > 0){
        result.imc_average = result.imc_sum/result.imc_count
    }
    if(result.hips_count > 0){
        result.hips_average = result.hips_sum/result.hips_count
    }
    if(result.waist_count > 0){
        result.waist_average = result.waist_sum/result.waist_count
    }
    if(result.fat_mass_count > 0){
        result.fat_mass_average = result.fat_mass_sum/result.fat_mass_count
    }
    if(result.muscle_mass_count > 0){
        result.muscle_mass_average = result.muscle_mass_sum/result.muscle_mass_count
    }
    if(result.icc_male_count > 0){
        result.icc_male_average = result.icc_male_sum/result.icc_male_count
    }
    if(result.icc_female_count > 0){
        result.icc_female_average = result.icc_female_sum/result.icc_female_count
    }

    return result


}

export const getRiskGroupByDiagnostic = (users, first) => {
    let result = [0,0,0]
    let green = 0;
    let yellow = 0;
    let red = 0;

    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.objective_id === 4){
            //console.log(_appointment)
            if(_appointment.risk_level_id === 1) green++;
            if(_appointment.risk_level_id === 2) yellow++;
            if(_appointment.risk_level_id === 3) red++;
        }


    }

    let total = green + yellow + red

    result = {
        labels:catalogs.risk_levels.map(item => item.label),
        data:[green, yellow, red],
        colors:catalogs.risk_levels.map(item => item.color),
        users_count:total
    }
    return {
        labels:catalogs.risk_levels.map(item => item.label),
        data:[green, yellow, red],
        colors:catalogs.risk_levels.map(item => item.color),
        users_count:total
    }



}


export const getPathologiesAnalyticsData = (users, first) => {
    let result = [0,0,0]
    let personal_asthma=0
    let personal_cancer=0
    let personal_diabetes=0
    let personal_gastrointestinal_system_diseases=0
    let personal_gout=0
    let personal_heart_diseases=0
    let personal_high_cholesterol=0
    let personal_hypertension=0
    let personal_immunosuppressants_diseases=0
    let personal_obesity=0
    let personal_other=0
    let personal_overweight=0
    let personal_polycystic_ovary_syndrome=0
    let personal_pre_diabetes=0
    let personal_psychological_psychiatric_diseases=0
    let personal_renal_insufficiency=0
    let personal_thyroid_diseases=0
    let total_users = 0
    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.objective_id === 4){
            //console.log(_appointment)
            total_users++
            if(_appointment.personal_asthma > 0) personal_asthma++;
            if(_appointment.personal_cancer > 0) personal_cancer++;
            if(_appointment.personal_diabetes > 0) personal_diabetes++;
            if(_appointment.personal_gastrointestinal_system_diseases > 0) personal_gastrointestinal_system_diseases++;
            if(_appointment.personal_gout > 0) personal_gout++;
            if(_appointment.personal_heart_diseases > 0) personal_heart_diseases++;
            if(_appointment.personal_high_cholesterol > 0) personal_high_cholesterol++;
            if(_appointment.personal_hypertension > 0) personal_hypertension++;
            if(_appointment.personal_immunosuppressants_diseases > 0) personal_immunosuppressants_diseases++;
            if(_appointment.personal_obesity > 0) personal_obesity++;
            if(_appointment.personal_other > 0) personal_other++;
            if(_appointment.personal_overweight > 0) personal_overweight++;
            if(_appointment.personal_polycystic_ovary_syndrome > 0) personal_polycystic_ovary_syndrome++;
            if(_appointment.personal_pre_diabetes > 0) personal_pre_diabetes++;
            if(_appointment.personal_psychological_psychiatric_diseases > 0) personal_psychological_psychiatric_diseases++;
            if(_appointment.personal_renal_insufficiency > 0) personal_renal_insufficiency++;
            if(_appointment.personal_thyroid_diseases > 0) personal_thyroid_diseases++;

        }


    }

    let total = personal_asthma + personal_cancer + personal_diabetes 
    + personal_gastrointestinal_system_diseases + personal_gout + personal_heart_diseases 
    + personal_high_cholesterol + personal_hypertension + personal_immunosuppressants_diseases 
    + personal_obesity + personal_other + personal_overweight 
    + personal_polycystic_ovary_syndrome + personal_pre_diabetes + personal_psychological_psychiatric_diseases 
    + personal_renal_insufficiency + personal_thyroid_diseases 

    result = {
        labels:catalogs.risk_levels.map(item => item.label),
        data:[green, yellow, red],
        colors:catalogs.risk_levels.map(item => item.color),
        users_count:total_users
    }
    return {
        labels: ["Asma","Cáncer","Diabetes","Enfermedades gastrointestinales","Gota","Enfermedades del corazón, infartos o embolias","Colesterol o triglicéridos altos","Hipertensión","Enf con inmunosupresores","Obesidad","Otros","Sobrepeso","SOP","Pre Diabetes","Problemas psicológicos o psiquiátricos","IRC","Problemas tiroideos"],
        data:[
            personal_asthma, personal_cancer, personal_diabetes,
            personal_gastrointestinal_system_diseases, personal_gout, personal_heart_diseases,
            personal_high_cholesterol, personal_hypertension, personal_immunosuppressants_diseases,
            personal_obesity, personal_other, personal_overweight,
            personal_polycystic_ovary_syndrome, personal_pre_diabetes, personal_psychological_psychiatric_diseases,
            personal_renal_insufficiency, personal_thyroid_diseases
        ],
        colors:[
            green[300],
            blue[300],
            purple[300],
            red[300],
            teal[300],
            pink[300],
            amber[300],
            lightBlue[300],
            indigo[300],
            orange[300],
            deepPurple[300],
            orange[300],
            deepOrange[300],
            lime[300],
            cyan[300],
            brown[300],
            blueGrey[200]
        ],
        users_count:total_users
    }



}

export const getIMCGroupByDiagnostic = (users, first) => {
    let result = [0,0,0]
    let low_weight = 0;
    let normal_weight = 0;
    let overweight_weight = 0;
    let obesity_one_weight = 0;
    let obesity_two_weight = 0;
    let obesity_three_weight = 0;


    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.imc){
            const value = _appointment.imc
            //console.log(_appointment)
            if(value > 0 && value <18.5) low_weight++;
            if(value >= 18.5 && value <25) normal_weight++;
            if(value >= 25 && value <30) overweight_weight++;
            if(value >= 30 && value <35) obesity_one_weight++;
            if(value >= 35 && value <40) obesity_two_weight++;
            if(value >= 40 && value <99999999) obesity_three_weight++;
        }


    }

    let total = low_weight + normal_weight + overweight_weight + obesity_one_weight + obesity_two_weight + obesity_three_weight

    result = {
        labels:catalogs.imc_diagnostics.map(item => item.label),
        data:[low_weight, normal_weight, overweight_weight, obesity_one_weight, obesity_two_weight, obesity_three_weight],
        colors:catalogs.imc_diagnostics.map(item => item.color),
        users_count:total
    }
    return result

}

export const getICCByGenderGroupByDiagnostic = (users, gender_id) => {
    let result = [0,0,0]
    let no_risk = 0;
    let high_risk = 0;

    let _users = users.filter(el => el.gender_id === gender_id)


    for (let j = 0; j < _users.length; j++) {
        const user = _users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.icc){
            const value = _appointment.icc
            //console.log(_appointment)
            if(gender_id === 1){
                if(value < .95){
                    no_risk++;
                }else{
                    high_risk++;
                } 
            }else{
                if(value < .85){
                    no_risk++;
                }else{
                    high_risk++;
                } 
            }
            
        }


    }

    let total = no_risk + high_risk 

    result = {
        labels:catalogs.icc_diagnostics.map(item => item.label),
        data:[no_risk, high_risk],
        colors:catalogs.icc_diagnostics.map(item => item.color),
        users_count:total
    }
    return result

}

export const getAppointmentTypeGroupData = (users, first) => {
    let result = [0,0,0]
    let in_presence = 0;
    let remote = 0;


    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.appointment_type_id){
            const value = _appointment.appointment_type_id
            //console.log(_appointment)
            if(value === 6){
                in_presence++;
            }else{
                remote++;
            }
        }


    }

    let total = in_presence + remote;

    result = {
        labels:["Presencial", "Online"],
        data:[in_presence, remote],
        colors:[blue[500], blue[300]],
        users_count:total
    }
    return result

}

export const getDoubleAppointmentTypeGroupData = (users, first) => {
    let result = [0,0,0]
    let in_presence = 0;
    let remote = 0;


    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null

        if(user.appointments_in_period.length > 1){ // Cuenta que hayan mas de dos consultas en el periodo
            _appointment = user.appointments_in_period[0]
            if(_appointment && _appointment.appointment_type_id){
                const value = _appointment.appointment_type_id
                //console.log(_appointment)
                if(value === 6){
                    in_presence++;
                }else{
                    remote++;
                }
            }
        }
        
        


    }

    let total = in_presence + remote;

    result = {
        labels:["Presencial", "Online"],
        data:[in_presence, remote],
        colors:[blue[500], blue[300]],
        users_count:total
    }
    return result

}

export const getObjectiveByGroupData = (users, first) => {
    let result = [0,0,0]
    let weight_control = 0;
    let health_life = 0;
    let physical_activity = 0;
    let risk_group = 0;
    let pregnancy = 0;
    let lactance = 0;


    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        let _appointment = null
        if(user.appointments_in_period.length > 0){
            // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
            _appointment = user.appointments_in_period[0]
        }else if(user.appointments_before_period.length > 0){
            // Se toma la ultima
            const index = user.appointments_before_period.length - 1
            _appointment = user.appointments_before_period[index]
        }
        
        if(_appointment && _appointment.objective_id){
            const value = _appointment.objective_id
            //console.log(_appointment)
            if(value === APPOINTMENT_OBJECTIVES.WEIGHT_CONTROL) weight_control++;
            if(value === APPOINTMENT_OBJECTIVES.HEALTH_LIFE) health_life++;
            if(value === APPOINTMENT_OBJECTIVES.PHYSICAL_ACTIVITY) physical_activity++;
            if(value === APPOINTMENT_OBJECTIVES.RISK_GROUP) risk_group++;
            if(value === APPOINTMENT_OBJECTIVES.PREGNANCY) pregnancy++;
            if(value === APPOINTMENT_OBJECTIVES.LACTANCE) lactance++;
        }


    }

    let total = weight_control + health_life + physical_activity + risk_group + pregnancy + lactance

    result = {
        labels:catalogs.objectives.map(item => item.label),
        data:[weight_control, health_life, physical_activity, risk_group, pregnancy, lactance],
        colors:catalogs.objectives.map(item => item.color),
        users_count:total
    }
    return result

}

export const getAnaltyicsDatabyLocationbyMotive = (users, location_id) => {
    let result = []
    let filtered_users = []
    if(location_id === -1){
        filtered_users = users.filter(el => el.client_location_id === null)
    }else{
        filtered_users = users.filter(el => el.client_location_id === location_id)
    }

    for (let index = 0; index < catalogs.objectives.length; index++) {
        const objetive = catalogs.objectives[index];

        let filtered_users_objetive = []
        for (let j = 0; j < filtered_users.length; j++) {
            const user = filtered_users[j];
            let _appointment = null
            if(user.appointments_in_period.length > 0){
                // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
                _appointment = user.appointments_in_period[0]
            }else if(user.appointments_before_period.length > 0){
                // Se toma la ultima
                const index = user.appointments_before_period.length - 1
                _appointment = user.appointments_before_period[index]
            }
            if(_appointment.objective_id === objetive.value){
                filtered_users_objetive.push(user)
            }
            
        }
        //console.log(objetive.label)
        //console.log(filtered_users_objetive)

        const data = getAverageDataFromUsers(filtered_users_objetive)
        let imc_diagnostic = "-"
        if(data.imc_average){
            let diagnosis_imc_id = catalogs.imc_diagnostics.find(el => data.imc_average >= el.min && data.imc_average < el.max)
            imc_diagnostic = diagnosis_imc_id?.label ?? "-"
        }

        
        //console.log(data)

        result.push([
            objetive.label,
            filtered_users_objetive.length,
            data.weight_sum,
            data.imc_average,
            imc_diagnostic,
            data.waist_sum,
            data.hips_sum,
            data.waist_sum / (data.hips_sum > 0 ? data.hips_sum: 1),
            data.fat_mass_sum,
            data.muscle_mass_sum
        ])

    }

    let last_result = []
    let total_usercount = 0
    let total_weight = 0
    let total_imc = 0
    let total_waist = 0
    let total_hips = 0
    let total_icc = 0
    let total_fatmass = 0
    let total_musclemass = 0
    for (let i = 0; i < result.length; i++) {
        const element = result[i];
        total_usercount += element[1]
        total_weight += element[2]
        total_imc += element[3]
        total_waist += element[5]
        total_hips += element[6]
        total_icc += element[7]
        total_fatmass += element[8]
        total_musclemass += element[9]
        
    }

    result.push(["Totales", total_usercount, total_weight,total_imc, "", total_waist, total_hips, total_icc, total_fatmass, total_musclemass])

    return result
    

}

export const getQuestionaryAnalyticsData = (users, data_key, catalog) => {

    let result = []
    for (let i = 0; i < catalogs.digestion_statuses.length; i++) {
        const element = catalogs.digestion_statuses[i];
        let aux = 0
        for (let j = 0; j < users.length; j++) {
            const user = users[j];
            let _appointment = null
            if(user.appointments_in_period.length > 0){
                // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
                _appointment = user.appointments_in_period[0]
            }else if(user.appointments_before_period.length > 0){
                // Se toma la ultima
                const index = user.appointments_before_period.length - 1
                _appointment = user.appointments_before_period[index]
            }
            
            if(_appointment && _appointment[data_key]){
                const value = _appointment[data_key]
                if(value === element.value) aux++
            }
            
        }
        result.push(aux)
    }

    let total = result.reduce((accumulator, currentValue) => accumulator + currentValue, 0);


    result = {
        labels:catalog.map(item => item.label),
        data:result,
        colors:catalog.map(item => item.color),
        users_count:total
    }

    return result
}


export const getAppointmentPatientaSegmentType = async(users, idclient) => {
    let result = [0,0,0]
    let voluntary = 0;
    let risk = 0;

    const _currentusersrequest = await getPatients(idclient, {
        offset:0, limit:100000, 
    })

    const clientusers = _currentusersrequest.data



    for (let j = 0; j < users.length; j++) {
        const user = users[j];
        const userdata = clientusers.find(el => el.id_user === user?.user_id)
        if(userdata && userdata.patient_segment_type_id){
            if(userdata.patient_segment_type_id === 1) voluntary++;
            if(userdata.patient_segment_type_id === 2) risk++;
        }

    }

    console.log("Grupo de voluntarios", voluntary)
    console.log("Grupo de riegos", risk)

    

}

export const getAppointmentPatientaSegmentTypeBySite = async(users, idclient, locations=[]) => {
    let result = [0,0,0]
    

    const _currentusersrequest = await getPatients(idclient, {
        offset:0, limit:100000, 
    })

    const clientusers = _currentusersrequest.data

    let data = [["Sitio","Total de consultas","Voluntarios", "Riesgo", "Sin asignar"]]

    for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        const _usersfilter = users.filter(el => el.client_location_id === location.id_client_location)

        let voluntary = 0;
        let risk = 0;
        let totalappointments = 0
        let missing_users = 0

        for (let j = 0; j < _usersfilter.length; j++) {
            const user = _usersfilter[j];
            totalappointments = totalappointments + user.appointments_in_period.length
            const userdata = clientusers.find(el => el.id_user === user?.user_id)
            
            if(userdata?.patient_segment_type_id === 1){
                //voluntary++;
                voluntary = voluntary + user.appointments_in_period.length
            }
            if(userdata?.patient_segment_type_id === 2){
                //risk++;
                risk = risk + user.appointments_in_period.length
            }
            if(!userdata?.patient_segment_type_id){
                console.log(userdata)
                missing_users = missing_users + user.appointments_in_period.length
            }

        }


        data.push([
            location.name,
            Number(totalappointments),
            Number(voluntary),
            Number(risk),
            Number(missing_users)
        ])
    }

    let total = 0
    let totalvoluntray = 0
    let totalrisk = 0
    let totalmissing = 0

    for (let index = 1; index < data.length; index++) {
        const element = data[index];
        total += element[1]
        totalvoluntray += element[2]
        totalrisk += element[3]
        totalmissing += element[4]
        
    }

    data.push([
        "",
        Number(total),
        Number(totalvoluntray),
        Number(totalrisk),
        Number(totalmissing)
    ])

    console.log(JSON.stringify(data))

    

}